<template>
	<div class="container flex flex-col items-center mx-auto">
    <PageNotFound v-if="notFound" />
    <BasicSkeletonLoader v-else-if="!page" />
    <Component
        v-else
        :is="displayComponent"
        :page="page"
    />
	</div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useHead } from '@unhead/vue'
import { useApi } from '@/composables/useApi'
import { pageTypes } from '@/config/componentMap'
import BasicSkeletonLoader from '@/components/layout/skeleton/BasicSkeletonLoader.vue'
import PageNotFound from '@/pages/PageNotFound.vue'
import BlogComponent from '@/pages/BlogComponent.vue'
import PostComponent from '@/pages/PostComponent.vue'

const route = useRoute()

const { api } = useApi()

const page = ref(null)
const notFound = ref(false)
const canonicalHref = ref('')

useHead({
  title: computed(() => page.value?.title ?? ''),
  titleTemplate: '%s | ' + import.meta.env.VITE_SITE_TITLE ?? '',
  link: [
    { rel: 'canonical', href: computed(() => canonicalHref.value) },
  ],
})

const displayComponent = computed(() => page.value?.top_level ? PostComponent : BlogComponent)

function pageType(type) {
  return pageTypes[type]
}

api({
  url: `/page${route.fullPath}`,
  callback: data => {
    if (data.top_level === undefined || data.type === undefined || !pageType(data.type)) {
      console.error('Unknown page type: ' + data.type)
      notFound.value = true
    } else {
      page.value = data
    }
  },
  errorCallback: () => {
    notFound.value = true
  }
})

watch(route, () => {
  canonicalHref.value = (import.meta.env.VITE_APP_URL ?? '') + route.fullPath
}, { immediate: true })
</script>
